import React, { useMemo } from "react";
import { SFResponsive } from "@sf-core";
import SigninContainer from "./screens/signin";
import SigninForm from "./screens/signin/signinForm";
import TenantForm from "./screens/signin/tenantForm";
import LoadingScreen from "./screens/signin/loading";
import FatalError from "./screens/fatalError";
import UnAuthorizedScreen from "./screens/signin/unAuthorized";
import Maintenance from "./screens/maintenance";
import { BaseApp } from "@base-provider";
import { useTranslation } from "react-i18next";
import RoutesWrapper from "./screens/routesWrapper";
import { ROUTES } from "./constants/routes";

const App = () => {
  const { t } = useTranslation();

  const screens = useMemo(() => {
    return {
      loading: LoadingScreen,
      maintenance: Maintenance,
      unAuthorized: () => (
        <SigninContainer>
          <UnAuthorizedScreen />
        </SigninContainer>
      ),
      login: ({ onClick }) => (
        <SigninContainer>
          <SigninForm onClick={onClick} />
        </SigninContainer>
      ),
      tenantSelect: ({ onSelect }) => (
        <SigninContainer>
          <TenantForm onSelect={onSelect} />
        </SigninContainer>
      ),
      routesWrapper: ({ children }) => (
        <RoutesWrapper routes={ROUTES}>{children}</RoutesWrapper>
      ),
      fatalError: FatalError,
    };
  }, []);

  return (
    <>
      <BaseApp
        routes={ROUTES}
        screens={screens}
        documentTitle={t("rootGeneric.documentTitle")}
      />
      <SFResponsive />
    </>
  );
};

export default App;
